import { lazy } from "react";
import { Routes, Route, Navigate } from "react-router-dom";
import Navbar from "./components/Navbar";

const HomePage = lazy(() => import("./pages/HomePage"));
const LoginPage = lazy(() => import("./pages/LoginPage"));
const RegisterPage = lazy(() => import("./pages/RegisterPage"));
const ControllerPage = lazy(() => import("./pages/ControllerPage"));
const DisplayPage = lazy(() => import("./pages/DisplayPage"));
const SubtitlePage = lazy(() => import("./pages/SubtitlePage"));
const AnchorPage = lazy(() => import("./pages/AnchorPage"));
const LegacyRedirect = lazy(() => import("./pages/LegacyRedirect"));
const AdminLoginPage = lazy(() => import("./pages/AdminLoginPage"));
const AdminDashboard = lazy(() => import("./pages/AdminDashboard"));
const SettingsPage = lazy(() => import("./pages/SettingsPage"));
const ShortLinkPage = lazy(() => import("./pages/ShortLinkPage"));

// v1.16 路由（SPEC 2.2）
function Router() {
  return (
    <>
      <Navbar />
      <Routes>
        <Route path="/" element={<HomePage />} />
        <Route path="/login" element={<LoginPage />} />
        <Route path="/register" element={<RegisterPage />} />
        <Route path="/admin/" element={<AdminLoginPage />} />
        <Route path="/admin/dashboard" element={<AdminDashboard />} />
        <Route path="/settings" element={<SettingsPage />} />

        {/* 主控端：httpOnly Cookie + 成员校验 */}
        <Route path="/p/:projectId/room/:roomCode" element={<ControllerPage />} />
        {/* 显示端 / 字幕端：短时效 token，服务端权威 join */}
        <Route path="/p/:projectId/room/:roomCode/display" element={<DisplayPage />} />
        <Route path="/p/:projectId/room/:roomCode/subtitle" element={<SubtitlePage />} />
        {/* 主播显示端（anchor）：短时效 token，桌面全屏文稿 + 滚轮发布滚动 */}
        <Route path="/p/:projectId/room/:roomCode/anchor" element={<AnchorPage />} />
        {/* 短链接（房间码+端点）：/r/{roomCode}/display|subtitle → 兑换 token 后跳转 */}
        <Route path="/r/:roomCode/display" element={<ShortLinkPage endpoint="display" />} />
        <Route path="/r/:roomCode/subtitle" element={<ShortLinkPage endpoint="subtitle" />} />
        <Route path="/r/:roomCode/anchor" element={<ShortLinkPage endpoint="anchor" />} />

        {/* 旧路由：/controller/:roomId、/display/:roomId、/subtitle/:roomId → 解析重定向 */}
        <Route path="/controller/:roomId" element={<LegacyRedirect legacy="control" />} />
        <Route path="/display/:roomId" element={<LegacyRedirect legacy="display" />} />
        <Route path="/subtitle/:roomId" element={<LegacyRedirect legacy="subtitle" />} />

        {/* 项目根路径 → 解析到当前活跃房间 */}
        <Route path="/p/:projectId" element={<LegacyRedirect legacy="project" />} />

        <Route path="*" element={<Navigate to="/" replace />} />
      </Routes>
    </>
  );
}

export default Router;
